import {toLower} from '@servicenow/ui-internal';

/**
 * Parse the property value
 * @private
 *
 * @param {*} value The value of the property
 * @param {*} schemaType The type of the property defined in its schema
 */
export default function parse(value, schemaType, name, tagName) {
	if (schemaType === 'boolean' && value === '') return true;

	try {
		return JSON.parse(value);
	} catch (e) {
		// throw to take advantage of sandbox logging and dispatching
		throw new Error(
			`Parsing failed for property ${name} on component ${toLower(
				tagName
			)}: expected to be type ${schemaType} but received string.`
		);
	}
}
